import React from 'react';
import * as Yup from 'yup';
import { printAction } from "../../../../actions";
import { PRINT } from "../../../../consts/methods.consts";
import { StylishCell } from '../components/cells';


const SlidaFacilityEvaluationReportConfig = {
    searchApi: 'xceed.api.report.module_evaluation.get_slida_facility_evaluation_report',
    alert: 'Reminder: Specify a program to receive reports.',
    title: 'SLIDA Facility Evaluation',
    // extraActionsAsMenu: true,
    pagination: false,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: 'Program Coordinator',
                    key: 'p_coordinator',
                    type: 'form-online-search',
                    methodBody: {},
                    optionMethod: 'xceed.api.report.module_evaluation.get_program_coordinators',
                    validationSchema: Yup.string().required('Program is required'),
                    onChange: (formik: any) => {
                        if (!formik.values.program) {
                            formik.setFieldValue('program', '')

                        }
                    }
                },
                {
                    label: 'Program',
                    key: 'program',
                    type: 'form-online-search',
                    methodBody: { "p_coordinator": "p_coordinator" },
                    optionMethod: 'xceed.api.report.module_evaluation.get_related_programs',
                    disabledBaseOn: ["p_coordinator"],
                },
            ]
        }],

    tableConfig: {
        column: [
            {
                header: "Program",
                accessor: "program_title",
                width: 250
            },
            {
                header: "Module",
                accessor: "program_module_title",
                width: 250
            },
            {
                header: "Facility Type",
                accessor: "section_name",
                width: 400
            },
            {
                header: "No. of Participants",
                accessor: "review_count",
                width: 50
            },
            {
                header: "Overall Marks",
                accessor: "overall_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
        ]
    },
    actions: [

        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program && filter.p_coordinator) {
                    setLoading(true)
                    setLoading(true);
                    try {
                        await printAction(PRINT.PRINT_SLIDA_FACILITY_EVALUATION_REPORT, { filter }, setLoading);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to print report");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                }
                else {
                    const error: any = new Error('Please select a program coordinator and program');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]
}

export default SlidaFacilityEvaluationReportConfig